import { Component, OnInit, Input } from '@angular/core';
import { HistoryDrawerConfig } from './models/user-history.model';
import { StateSettingsHistoryDrawerService } from './service/state-settings-history-drawer.service';
import { VehicleHistoryDrawerService } from 'src/app/historial/services/vehicle-history-drawer.service';
import { configSections } from 'src/app/profile-config/services/user-config-panel.service';

@Component({
  selector: 'app-user-history-drawer',
  templateUrl: './user-history-drawer.component.html',
  styleUrls: ['./user-history-drawer.component.scss'],
})
export class UserHistoryDrawerComponent implements OnInit {
  @Input() filterOptionsBy : string = ""
  config: HistoryDrawerConfig = this.defaultConfigStatic();
  messageResponse: string = '';
  public configSections = configSections;
  
  constructor(
    private stateService: StateSettingsHistoryDrawerService,
    private vehicleHistoryDrawerService: VehicleHistoryDrawerService
  ) {}

  ngOnInit(): void {
    this.loadConfig();
  }

  saveConfig(): void {
    this.stateService.setConfig = this.config;
    // this.messageResponse = 'Configuración guardada correctamente.';
    // this.resetMessage();
    // Cerrar el panel de historial para que se apliquen los nuevos ajustes
    this.vehicleHistoryDrawerService.setStateDestroyedHistoryDrawer = true;
  }

  loadConfig(): void {
    const config = this.stateService.getCurrentConfig();
    if (config) {
      this.config = config;
      return;
    }
    // const saved = localStorage.getItem('historyDrawerConfig');
    // if (saved) {
    //   this.config = { ...this.config, ...JSON.parse(saved) };
    // }
  }

  resetConfig(): void {
    this.config = this.defaultConfigStatic();
    this.saveConfig();
    this.messageResponse =
      'Configuración restablecida a los valores predeterminados.';
    this.resetMessage();
  }

  private resetMessage() {
    setTimeout(() => {
      this.messageResponse = '';
    }, 3000);
  }

  private defaultConfigStatic(): HistoryDrawerConfig {
    return {
      showMovements: false,
      showStops: false,
      showStartRoute: false,
      showEndRoute: false,
      showFrames: false,
      showEvents: false,
      frameVariant: 'basic',
      routeWithDirection: true,
      animationDirection: true,
      routeWithSpeed: false,
      showGeofences: false,
      showCircularGeofences: false,
      showGeopoints: false,
    };
  }
}
